import { render } from "./ImportDossier.vue?vue&type=template&id=72430ca6"
import script from "./ImportDossier.vue?vue&type=script&lang=js"
export * from "./ImportDossier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__